'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { FOCUS_RING, INTERACTIVE_SURFACE } from '@common/components/interaction';
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { GlobalDesktopSideAdBanner } from '@/app/_components/ads';
import { CustomLink } from '@/app/_components/CustomLink';
import { PageNavigation } from '@/components/client';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { DONATION_ROUTES } from '@/constants';
import DollarCoinIcon from '../_assets/dollar-coin.svg';
import HandHeldWritingIcon from '../_assets/hand-held-writing.svg';
import { usePartnersDialog } from '../_hooks/usePartnersDialog';
import { GuideDialog } from './GuideDialog';
const PARTNERS_MENU = [{
  label: '내 수익',
  href: DONATION_ROUTES.PARTNERS.pathname
}, {
  label: '내 콘텐츠',
  href: DONATION_ROUTES.PARTNERS_CONTENTS.pathname
}, {
  label: '내 정산내역',
  href: DONATION_ROUTES.PARTNERS_REWARDS.pathname
}];
const PartnersSideNav = () => {
  const $ = _c(13);
  const pathname = usePathname() ?? "";
  const openGuideDialog = usePartnersDialog(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p className="font-700 text-Gray-900 typo-body2">웰로 파트너스</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== pathname) {
    t1 = PARTNERS_MENU.map(item => {
      const isActive = pathname === item.href;
      return <li key={item.href}><CustomLink href={item.href} aria-current={isActive ? "page" : undefined} className={cn("rounded-xxsmall transition-colors duration-150 typo-body3 hover:text-Gray-900 active:text-Gray-700", FOCUS_RING, isActive ? "font-700 text-Gray-900" : "font-500 text-Gray-550")}>{item.label}</CustomLink></li>;
    });
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <ul className="flex flex-col gap-12 pl-12">{t1}</ul>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn(INTERACTIVE_SURFACE, "group flex flex-col items-start gap-4 rounded-small bg-Gray-25 p-12 text-left");
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-Gray-550 typo-caption1">처음이라면 꼭 확인하세요</span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="flex items-center gap-2 font-700 text-Gray-800 typo-body4">작성 가이드 보기<SvgChevronright aria-hidden={true} className="size-12 transition-transform group-hover:translate-x-1 group-focus-visible:translate-x-1" /></span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== openGuideDialog) {
    t6 = <button className={t3} onClick={openGuideDialog}>{t4}{t5}</button>;
    $[8] = openGuideDialog;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t6) {
    t7 = <nav aria-label={"\uD30C\uD2B8\uB108\uC2A4 \uBA54\uB274"} className="hidden w-196 shrink-0 flex-col gap-16 pr-32 xl:flex">{t0}{t2}{t6}</nav>;
    $[10] = t2;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
interface PartnersShellProps {
  children: React.ReactNode;
  mobileTitle?: string;
  mobileDescription?: string;
  banner?: React.ReactNode;
}
export const PartnersShell = t0 => {
  const $ = _c(21);
  const {
    children,
    mobileTitle,
    mobileDescription,
    banner
  } = t0;
  const pathname = usePathname() ?? "";
  const openGuideDialog = usePartnersDialog(_temp2);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HandHeldWritingIcon aria-hidden={true} className="size-22" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== openGuideDialog) {
    t2 = <Button aria-label={"\uC791\uC131 \uAC00\uC774\uB4DC \uBCF4\uAE30"} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text" onClick={openGuideDialog}>{t1}</Button>;
    $[1] = openGuideDialog;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== pathname) {
    t3 = pathname === DONATION_ROUTES.PARTNERS_REWARDS.pathname ? null : <Button asChild={true} aria-label={"\uB0B4 \uC815\uC0B0\uB0B4\uC5ED\uC73C\uB85C \uC774\uB3D9"} className="relative size-26 p-0 before:absolute before:-inset-9 before:content-['']" dimensions="H26" theme="primary-text"><CustomLink href={DONATION_ROUTES.PARTNERS_REWARDS.pathname}><DollarCoinIcon aria-hidden={true} className="size-24" /></CustomLink></Button>;
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <PageNavigation title={"\uC6F0\uB85C \uD30C\uD2B8\uB108\uC2A4"} isNotUsedHomeButton={true} donationHomeButton={true}>{t2}{t3}</PageNavigation>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PartnersSideNav />;
    t6 = <GlobalDesktopSideAdBanner />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  let t7;
  if ($[10] !== mobileDescription || $[11] !== mobileTitle) {
    t7 = mobileTitle ? <div className="flex flex-col gap-4 p-20 xl:hidden"><h1 className="font-700 text-Gray-900 typo-body2">{mobileTitle}</h1>{mobileDescription ? <p className="text-Gray-700 typo-caption1">{mobileDescription}</p> : null}</div> : null;
    $[10] = mobileDescription;
    $[11] = mobileTitle;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== children || $[14] !== t7) {
    t8 = <DesktopPageShell variant="wide" className="pb-64 xl:px-40 xl:pt-40" leftAside={t5} rightAside={t6}>{t7}{children}</DesktopPageShell>;
    $[13] = children;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <GuideDialog />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== banner || $[18] !== t4 || $[19] !== t8) {
    t10 = <>{t4}{banner}{t8}{t9}</>;
    $[17] = banner;
    $[18] = t4;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
function _temp(state) {
  return state.openGuideDialog;
}
function _temp2(state) {
  return state.openGuideDialog;
}